export default __webpack_public_path__ + "static/media/health-card-bg.40dd40a4.svg";